import { useTranslation } from 'react-i18next'
import { formatCurrency } from '../../../../domain/vos/format-currency'
import { CardInfoBox } from '../../../components/card-info-box'
import { LoadingCard } from '../../../components/loading-card'

type TotalPaidProps = {
  amount?: number
  isLoading: boolean
}

export const TotalPaid = ({ isLoading, amount }: TotalPaidProps) => {
  const { t } = useTranslation()

  if (isLoading) {
    return <LoadingCard />
  }

  return (
    <CardInfoBox
      title={t('smartInstallmentsSummaries.totalPaid.title')}
      description={t('smartInstallmentsSummaries.totalPaid.description')}
      current={formatCurrency(amount ?? 0)}
    />
  )
}
